module.exports = __webpack_public_path__ + "img/Kristall.d4dc4817.jpg";